var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLockedFile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "120px",
    height: "99px",
    viewBox: "0 0 120 99",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Aktualnosci",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "aktualnosci---artykul---brak-dostepu",
    transform: "translate(-580.000000, -264.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "info",
    transform: "translate(240.000000, 184.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(340.000000, 80.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    fill: "#F5F6FA"
  }, /*#__PURE__*/React.createElement("g", {
    id: "folder-lock"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M98.6450022,99 L20.7673689,99 C9.345316,99 0,89.6210526 0,80.7631579 L0,0 L41.5347378,0 L51.9184222,15.6315789 L119.412371,15.6315789 L119.412371,78.1578947 C119.412371,89.6210526 110.067055,99 98.6450022,99 Z",
    id: "Folder"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "lock",
    transform: "translate(46.948454, 38.783505)",
    fill: "#A7A9AC",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.2680412,0 C18.8955749,0 23.4742268,4.32890722 23.4742268,9.64948454 L23.4746744,14.378122 C25.2240787,14.7563734 26.5360825,16.2892478 26.5360825,18.1159794 L26.5360825,31.8943299 C26.5360825,34.0039485 24.786262,35.7216495 22.6337174,35.7216495 L3.90236507,35.7216495 C1.7498205,35.7216495 0,34.0039485 0,31.8943299 L0,18.1159794 C0,16.2892478 1.31200377,14.7563734 3.06140811,14.378122 L3.06185567,9.64948454 C3.06185567,4.32890722 7.64050753,0 13.2680412,0 Z M22.6337174,15.8195876 L3.90236507,15.8195876 C2.6114627,15.8195876 1.56094603,16.8499021 1.56094603,18.1159794 L1.56094603,31.8943299 C1.56094603,33.1604072 2.6114627,34.1907216 3.90236507,34.1907216 L22.6337174,34.1907216 C23.9246198,34.1907216 24.9751364,33.1604072 24.9751364,31.8943299 L24.9751364,18.1159794 C24.9751364,16.8499021 23.9246198,15.8195876 22.6337174,15.8195876 Z M13.2680412,19.3917526 C15.519934,19.3917526 17.3505155,21.223967 17.3505155,23.4742268 C17.3505155,25.3723536 16.0480261,26.9730341 14.2888557,27.4275199 L14.2886598,30.8737113 C14.2886598,31.2962474 13.8314227,31.6391753 13.2680412,31.6391753 C12.7046598,31.6391753 12.2474227,31.2962474 12.2474227,30.8737113 L12.2472267,27.4275199 C10.4880563,26.9730341 9.18556701,25.3723536 9.18556701,23.4742268 C9.18556701,21.223967 11.0161485,19.3917526 13.2680412,19.3917526 Z M13.2680412,21.0247423 C11.9175588,21.0247423 10.8185567,22.1237443 10.8185567,23.4742268 C10.8185567,24.5501112 11.5160689,25.4663865 12.4825637,25.7945233 C12.6682739,25.6237954 12.951392,25.5154639 13.2680412,25.5154639 C13.5846905,25.5154639 13.8678086,25.6237954 14.055058,25.7937052 C15.0200136,25.4663865 15.7175258,24.5501112 15.7175258,23.4742268 C15.7175258,22.1237443 14.6185237,21.0247423 13.2680412,21.0247423 Z M13.2680412,1.48453608 C8.50724822,1.48453608 4.63203807,5.1468866 4.63203807,9.64948454 L4.632,14.288 L21.904,14.288 L21.9040444,9.64948454 C21.9040444,5.1468866 18.0288343,1.48453608 13.2680412,1.48453608 Z",
    id: "Combined-Shape"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockedFile);
export default __webpack_public_path__ + "static/media/lockedFile.744d8d7bf9c1e5f1273b3b6344c1a4ad.svg";
export { ForwardRef as ReactComponent };